// extracted by mini-css-extract-plugin
var _1 = "page_container__S-q0A";
var _2 = "page_content__OMzm8";
var _3 = "page_navigation__lV6tE";
export { _1 as "container", _2 as "content", _3 as "navigation" }
